import { useState, useEffect } from "react";
import userSession from "../Constant/auth";
import { APP_SERVICES_URL } from "../Constant/constant";

const useSenapiPumps = () => {
  const [pumpData, setPumpData] = useState([]);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line
  const [error, setError] = useState(null);
  const { CustID, authHeader, site } = userSession;
  useEffect(() => {
    const fetchPumpData = async () => {
      try {
        const response = await fetch(
          `${APP_SERVICES_URL}/senapi/${CustID}/pumps?siteName=${site.name}`,
          {
            method: "GET",
            headers: {
              Authorization: authHeader,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch pump data");
        }

        const pumpData = await response.json();
        const filteredPump = pumpData.filter(item => item.status !== 'DELETED');
        setPumpData(filteredPump);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching pump data:", error);
        setError(error);
        setLoading(false);
      }
    };

    fetchPumpData();
    // eslint-disable-next-line
  }, [CustID, site]);

  return { pumpData };
};

export default useSenapiPumps;
